import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const columns = [
  {
    title: "逛逛栏目",
    links: [
      { label: "吃瓜快讯", to: "/news" },
      { label: "专题栏目", to: "/topics" },
      { label: "行业观察", to: "/topics" },
      { label: "常见问题", to: "/faq" },
    ],
  },
  {
    title: "关于瓜田",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "读者纠错", to: "/contact" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-accent-900 text-accent-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-accent-100/80">
              {siteInfo.description}
            </p>
            <p className="mt-4 text-sm text-accent-100/70">
              联系邮箱：<span className="text-background-50">{siteInfo.email}</span>
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-accent-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-accent-100/80 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-accent-50">每日瓜报订阅</h4>
            <p className="mt-4 text-sm leading-relaxed text-accent-100/80">
              留个邮箱，把当天最值得吃的瓜整理好发给你。
            </p>
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line"></i> 去订阅
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-accent-700/60 pt-6 text-xs text-accent-100/70 sm:flex-row sm:items-center">
          <p>© 2026 {siteInfo.name} · 内容仅供娱乐讨论，不构成对任何个人的事实指控。</p>
          <p className="flex flex-wrap items-center gap-4">
            <Link to="/faq" className="transition-colors hover:text-background-50">
              免责声明
            </Link>
            <Link to="/about" className="transition-colors hover:text-background-50">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}